//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { DeleteIcon } from "../../../Icons/DeleteIocn";

interface ITableAction {
  onClick: () => void;
  disabled: boolean;
}

const TableDeleteButton = (props: ITableAction) => {
  return (
    <button
      onClick={props?.onClick}
      disabled={props.disabled}
      className={tw`cursor-pointer`}
    >
      <DeleteIcon color={"var(--primary)"} />
    </button>
  );
};

export default TableDeleteButton;
